import bundledSportMap from "tokens/build/js/sport-map";
import { getSportsMap, hasSportsMap } from "./useCuiConfig";

export type SportInfoReturnType = {
  name: string;
  alternateNames: string[];
  metadata: {
    images: {
      icon: {
        name: string;
        type: string;
      };
      backgrounds: Array<{
        name: string;
        type: string;
        ext: string;
        folder: string;
      }>;
    };
  };
  cuiSportId: string;
} | null | undefined;

function getActiveSportsMap(): Record<string, unknown> {
  if (hasSportsMap()) return getSportsMap()!;
  return bundledSportMap;
}

export const getSportInfo = (sport): SportInfoReturnType => {
  const searchTerm = sport && typeof sport === "string" ? sport?.toLowerCase() : "";
  const map = getActiveSportsMap();
  if (searchTerm in map) return map[searchTerm] as SportInfoReturnType;
  return null;
};
